import { get } from 'lodash-es'
import type { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'
import type { Nullable } from '@/types'

export const getCommonErrors = (error: TmApiValidationError): string[] => get(error.getErrors(), 'errors.common') || []

export const getCommonError = (error: TmApiValidationError): Nullable<string> => getCommonErrors(error)[0] || null

export const toError = (e: unknown): Error => (e instanceof Error ? e : new Error(String(e)))
